import { render, staticRenderFns } from "./NFIUReport.vue?vue&type=template&id=19518464&"
import script from "./NFIUReport.vue?vue&type=script&lang=js&"
export * from "./NFIUReport.vue?vue&type=script&lang=js&"
import style0 from "./NFIUReport.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports